import { selfAxios } from "../../../../axios/selfAxios.js";
async function opPostQueryProductionOrderRelatedObjRuleList(params) {
  const res = await selfAxios.post(`/designordercenter/linkage/queryProductionOrderRelatedObjRuleList`, params);
  return res.data;
}
export { opPostQueryProductionOrderRelatedObjRuleList };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/designordercenter/linkage/queryProductionOrderRelatedObjRuleList/post.js